import {pxToRem} from '../../utills/pxToRem'
import sizes from '../../theme/foundations/sizes'

const {md} = sizes.container

export const contentStyle = {
    maxWidth: '1400px',
    display: 'flex',
    width: '100%',
    margin: '0 auto',
    [`@media (max-width: ${md})`]: {
        flexDirection: 'column'
    },
    '.leftnav': {
        width: '22%',
        margin: `${pxToRem(15)} ${pxToRem(15)} ${pxToRem(15)} ${pxToRem(15)}`,
        [`@media (max-width: ${md})`]: {
            width: '100%',
            margin: 0,
            padding: pxToRem(15),
            minHeight: pxToRem(250)
        }
    },
    '.content': {
        flex: 1,
        marginLeft: pxToRem(54),
        position: 'relative',
        [`@media (max-width: ${md})`]: {
            marginLeft: 0
        }
    }
}
